import React, { useEffect, useState } from 'react';

import config from '../../config';
import ClaimsAccordion from '../accordion/ClaimsAccordion';
import {
  ClaimsAccordionHeader,
  ClaimsAccordionLink,
  ClaimsAccordionListItem,
  ClaimsAccordionText,
  ClaimsAccordionTitle,
  ClaimsAccordionWrapper,
} from './ClaimsAccordionSection.style';

const ClaimsAccordionSection = () => {
  const [openIndex, setOpenIndex] = useState<number | undefined>(undefined);
  const handleOnClick = (index?: number) =>
    setOpenIndex(openIndex === index ? undefined : index);
  useEffect(() => {
    setOpenIndex(undefined);
  }, []);

  const accordionData = [
    {
      header: (
        <ClaimsAccordionHeader
          $isOpen={openIndex === 0}
          data-testid="claims-tab-header"
        >
          How long will my claim take?
        </ClaimsAccordionHeader>
      ),
      content: (
        <div data-testid="claims-tab-content">
          <ClaimsAccordionText>
            Understandably, this can vary on a claim-by-claim basis, but
            assuming we have all the information we need – we aim to assess your
            claim within three working days. If your claim is accepted – we’ll
            pay the agreed amount within 5-7 days.
          </ClaimsAccordionText>
        </div>
      ),
      index: 0,
    },
    {
      header: (
        <ClaimsAccordionHeader
          $isOpen={openIndex === 1}
          data-testid="claims-tab-header"
        >
          What is an excess?
        </ClaimsAccordionHeader>
      ),
      content: (
        <div data-testid="claims-tab-content">
          <ClaimsAccordionText>
            An excess is the amount you agree to pay towards each condition you
            claim for - each year you claim for it. You'll have chosen this
            amount when you purchased your pet insurance policy, but if you're
            not sure of the amount, you'll find this information detailed on
            your policy schedule.{' '}
            <ClaimsAccordionLink
              href={config.HOME_LOGIN_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Click here
            </ClaimsAccordionLink>{' '}
            to access your online account where you can view this.
          </ClaimsAccordionText>
        </div>
      ),
      index: 1,
    },
    {
      header: (
        <ClaimsAccordionHeader
          $isOpen={openIndex === 2}
          data-testid="claims-tab-header"
        >
          What is Co-pay?
        </ClaimsAccordionHeader>
      ),
      content: (
        <div data-testid="claims-tab-content">
          <ClaimsAccordionText>
            A co-payment is the contribution (a percentage) that you pay towards
            a claim, after the excess has been deducted. You&apos;ll have
            selected your co-payment amount at the time you bought your policy.
            If you can&apos;t remember what this, again you can find this on
            your policy schedule.
          </ClaimsAccordionText>
        </div>
      ),
      index: 2,
    },
    {
      header: (
        <ClaimsAccordionHeader
          $isOpen={openIndex === 3}
          data-testid="claims-tab-header"
        >
          Pre-existing conditions
        </ClaimsAccordionHeader>
      ),
      content: (
        <div data-testid="claims-tab-content">
          <ClaimsAccordionText>
            A pre-existing condition is something your pet has shown symptoms
            of, has been treated for, has received medication for, or you've
            received advice on before this policy started - this includes
            anything your vet has noted in your pet's medical history.
          </ClaimsAccordionText>
        </div>
      ),
      index: 3,
    },
    {
      header: (
        <ClaimsAccordionHeader
          $isOpen={openIndex === 4}
          data-testid="claims-tab-header"
        >
          Some things that aren&apos;t covered
        </ClaimsAccordionHeader>
      ),
      content: (
        <div data-testid="claims-tab-content">
          <ClaimsAccordionText>
            Under the terms of your policy, there may be certain limits for each
            type of claim or treatment. For example: Dental care, Specialist
            diagnostics (MRI, CT or PET scans), Treatment food.
          </ClaimsAccordionText>
        </div>
      ),
      index: 4,
    },
    {
      header: (
        <ClaimsAccordionHeader
          $isOpen={openIndex === 5}
          data-testid="claims-tab-header"
        >
          What could delay my claim?
        </ClaimsAccordionHeader>
      ),
      content: (
        <div data-testid="claims-tab-content">
          <ClaimsAccordionText>
            We really hope this isn&apos;t the case, however, sometimes if we
            don&apos;t receive all the information we need at the time the claim
            is submitted, we may need to ask you or your vet to supply this
            which can slow things down a little. For example, we require the
            following supporting documents:
            <ul>
              <ClaimsAccordionListItem>
                Clinical history
              </ClaimsAccordionListItem>
              <ClaimsAccordionListItem>
                Full details and itemised estimate for the treatment you wish to
                carry out.
              </ClaimsAccordionListItem>
              <ClaimsAccordionListItem>
                Information provided by the referring vet (if applicable)
              </ClaimsAccordionListItem>
            </ul>
          </ClaimsAccordionText>
        </div>
      ),
      index: 5,
    },
  ];

  return (
    <div data-testid="claims-section-container">
      <ClaimsAccordionTitle>Commonly asked questions</ClaimsAccordionTitle>
      <ClaimsAccordionWrapper>
        {accordionData.map((tab) => (
          <ClaimsAccordion
            key={tab.index}
            header={tab.header}
            content={tab.content}
            index={tab.index}
            handleOnClick={handleOnClick}
            openIndex={openIndex}
          />
        ))}
      </ClaimsAccordionWrapper>
    </div>
  );
};

export default ClaimsAccordionSection;
